import initialState from './initialState'

const SHOW_SNACKBAR = function(state, payload) {
    Object.assign(state, payload)
}

/**
 * @description
 * Returns State to it's initial values
 * @param {*} state
 */
const RESET_STATE = function(state) {
    Object.assign(state, initialState())
}

export default {
    SHOW_SNACKBAR,
    RESET_STATE,
}
